export class CycleAnswers {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get cycle() {
        return this.parent;
    }
    get app() {
        return this.parent.app;
    }
    get frontalAnswer() {
        return this.allAnswersInCycle[this.cycle.frontalIndex];
    }
    /*
      get nextAnswer(): Answer  {
          return this.allAnswersInCycle[this.cycle.positionIndex + 1];
      }
  */
    get trayIndexOfFirstCycleAnswer() {
        return this.cycle.cycleIndex * this.app.tray.trayCycles.pensumPerCycle;
    }
    get posedAnswersInCycle() {
        return this.app.tray.trayAnswers.answersPosed.slice(this.trayIndexOfFirstCycleAnswer);
    }
    get completedAnswersInCycle() {
        return this.app.tray.trayAnswers.answersCompleted.slice(this.trayIndexOfFirstCycleAnswer);
    }
    get finishedAnswersInCycle() {
        return this.app.history.historyAnswers.answersFinished.slice(this.trayIndexOfFirstCycleAnswer);
    }
    get allAnswersInCycle() {
        return this.app.tray.trayAnswers.allAnswersInLine.slice(this.trayIndexOfFirstCycleAnswer, this.trayIndexOfFirstCycleAnswer + this.app.tray.trayCycles.pensumPerCycle);
    }
}
